import isEmpty from './isEmpty'
//--------------------
// build runes string
//--------------------
export default function buildRunesString(runes) {
  console.log('--------------------------')
  console.log('IN buildRunesString')
  // console.log('ADJS PASSED IN = ', window.$deepCopy(runes))

  if (isEmpty(runes)) {
    return ''
  }
  let runes_string = ''
  //------------
  // loop runes
  //------------
  runes.forEach((r) => {
    // console.log('PROCESSING RUNE name = ', r.name, ' / strength = ', r.strength)
    //------------------------
    // build this rune string
    //------------------------
    if (!isEmpty(r.name)) {
      let rune = r.name.charAt(0).toUpperCase() + r.name.slice(1) + ' (Str ' + r.strength + ')'
      // first adj pass
      if (isEmpty(runes_string)) {
        runes_string = rune
      } else {
          // subsequent adj passes
          runes_string += '. ' + rune
      }
    }
  })
  return runes_string
}
